module.exports = __webpack_public_path__ + "static/media/Rye-Regular.733a4710.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Rye-Regular.ttf
// module id = 3707
// module chunks = 68